export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';
    
export const CLIENT_ORIGIN = 
    process.env.CLIENT_ORIGIN || 'http://localhost:3000';


// WEBPACK FOOTER //
// ./src/config.js